<template>
  <div class="xl:col-span-4 lg:col-span-5 col-span-12">
    <Card v-if="loading" bodyClass="pb-0 px-6 pt-6" :title="$t('menuItems.boost orders applicants')"
          :subtitle="$t('message.order title') +': '+ $route.query.orderTitle"
          headerClass="flex-col sm:flex-row gap-4 sm:gap-2 !items-start"
          headerSlotClass="w-full sm:w-max"
          beforeTitleSlotClass="flex flex-col sm:flex-row gap-4" noborder>
      <div class="-mx-6">
        <TableSkeleton :count="4" :cols="width >= 768 ? 6 : 3"/>
      </div>
    </Card>
    <Card v-else-if="applicants.length > 0 && !$route.query.user" bodyClass="pb-0 px-6 pt-6"
          :title="$t('menuItems.boost orders applicants')"
          :subtitle="$t('message.order title') +': '+ $route.query.orderTitle"
          headerClass="flex-col sm:flex-row gap-4 sm:gap-2 !items-start"
          headerSlotClass="w-full sm:w-max"
          beforeTitleSlotClass="flex flex-col sm:flex-row gap-4" noborder>

      <template #header>
        <InputGroup
            v-model="searchTerm"
            :placeholder="$t('message.search.label')"
            type="text"
            prependIcon="heroicons-outline:search"
            class-input="w-full sm:w-max"
            merged
        />
      </template>
      <div class="-mx-6">
        <List :accounts="applicants" :_searchTerm="searchTerm"
              :_title="$t('menuItems.boost orders applicants')"
              :_emptyListMessage="$t('message.no user has booked boost orders yet')"
              :_loading="loading"/>
      </div>
    </Card>
    <Card v-else-if="applicants.length === 0" bodyClass="pb-0 px-6 pt-6"
          :title="$t('menuItems.boost orders applicants')"
          :subtitle="$t('message.order title') +': '+ $route.query.orderTitle"
          headerClass="flex-col sm:flex-row gap-4 sm:gap-2 !items-start"
          headerSlotClass="w-full sm:w-max"
          beforeTitleSlotClass="flex flex-col sm:flex-row gap-4" noborder>
      <div class="flex justify-center flex-wrap items-center flex-col text-center gap-8 mb-10">
        <img width="220" src="@/assets/images/all-img/no-data1.png" alt=""/>
        <p class="font-normal text-base text-slate-500 dark:text-slate-300">
          {{ $t('message.there is no applicant for this order') }}
        </p>
      </div>
    </Card>
    <ApplicantDetails v-else-if="$route.query.user" @update-list="getApplicants"/>
  </div>
</template>
<script setup>
import Card from "@/components/Card/index.vue";
import {ref, onMounted, computed} from "vue";
import List from "@/views/manageApplicants/list.vue";
import ApplicantDetails from "@/views/manageApplicants/boost/applicantDetails/index.vue";
import {useI18n} from "vue-i18n";
import {useOrdersStore} from "@/stores/orders.js";
import {useRoute} from "vue-router";
import InputGroup from "@/components/InputGroup/index.vue";
import Tooltip from "@/components/Tooltip/index.vue";
import Icon from "@/components/Icon/index.vue";
import TableSkeleton from "@/components/Skeleton/Table.vue";
import {useManagementStore} from "@/stores/management.js";

const managementStore = useManagementStore();

const route = useRoute()
const applicants = ref([])
const ordersStore = useOrdersStore();
const width = ref(0);
const loading = ref(false);
const searchTerm = ref("")
const handleResize = () => {
  width.value = window.innerWidth;
};
onMounted(() => {
  window.addEventListener("resize", handleResize);
  handleResize();
});

const {locale} = useI18n({useScope: 'global'})
const selectedApplicant = computed(() => managementStore.getSelectedApplicant);

async function getApplicants() {
  loading.value = true;
  await ordersStore.action_getBoostHotOrderApplicants({id: route.params.orderID})
  if (ordersStore.getBoostOrderApplicants.length) {
    applicants.value = ordersStore.getBoostOrderApplicants
  }
  loading.value = false
}

getApplicants();
</script>
<style lang="scss">
.singleEmail-enter-active {
  animation: fade-in-right 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.singleEmail-leave-active {
  animation: fade-in-right 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both reverse;
}

.singleEmail-fa-enter-active {
  animation: fade-in-left 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.singleEmail-fa-leave-active {
  animation: fade-in-left 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both reverse;
}

@-webkit-keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}


@-webkit-keyframes fade-in-left {
  0% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-in-left {
  0% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}


@-webkit-keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.email_height {
  height: calc(var(--vh, 1vh) * 100 - 12.1rem);
}

@media (max-width: 768px) {
  .email_height {
    height: calc(var(--vh, 1vh) * 100 - 10.5rem);
  }
}
</style>
